import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

import { Tooltip, IconButton, Switch, TableFooter, TablePagination } from '@mui/material';
import { BasicTableDiv } from './styles';
import { useState } from 'react';
import TablePaginationActions from './pagination';
import GeneratorsRow from './campaigns/generators';
import TransformersRow from './campaigns/transformers';
import { useEffect } from 'react';
import { OrderBy } from 'react-lodash'
import EnhancedTableHead from './Header';
import { getComparator, stableSort } from '../utils/sortTable';
import CalendarsRow from './campaigns/calendars';
import EnginesRow from './campaigns/engines';
import ProductsRow from './campaigns/products';
import CampaignsRow from './campaigns/campaigns';
import ApiRow from './campaigns/api';
import DamRow from './campaigns/dam';
import ProjectRow from './campaigns/project';
import UserRow from './users/api';



const BasicTable = ({ type, rowsProps, headers, updateForm, onDelete, handleActive, updateEngine, releaseDam, resetPass, handleEnableDisable, handleUserCheckUncheck }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(type === 'engines' ? 'IdCampEngine' : (type === 'products' ? 'IdCampProduct' : 'IdCompany'));

  useEffect(() => {
    setRows(rowsProps)
  }, [rowsProps])

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <BasicTableDiv>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} size='medium' aria-label="simple table">
          <TableHead>
            <TableRow>
              <EnhancedTableHead headers={headers} orderBy={orderBy} order={order} handleRequestSort={handleRequestSort} />
            </TableRow>
          </TableHead>

          <TableBody>
            {rows && (rowsPerPage > 0
              ?
              stableSort(rows, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

              : stableSort(rows, getComparator(order, orderBy))).map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  {type === 'generators' && <GeneratorsRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive}></GeneratorsRow>}
                  {type === 'tranformers' && <TransformersRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive}></TransformersRow>}
                  {type === 'calendars' && <CalendarsRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive}></CalendarsRow>}
                  {type === 'engines' && <EnginesRow row={row} updateForm={updateForm} key={index} handleActive={handleActive}></EnginesRow>}
                  {type === 'products' && <ProductsRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive}></ProductsRow>}
                  {type === 'campaigns' && <CampaignsRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive} updateEngine={updateEngine}></CampaignsRow>}
                  {type === 'api' && <ApiRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive} updateEngine={updateEngine}></ApiRow>}
                  {type === 'dam' && <DamRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} releaseDam={releaseDam} updateEngine={updateEngine}></DamRow>}
                  {type === 'project' && <ProjectRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} handleActive={handleActive} updateEngine={updateEngine}></ProjectRow>}
                  {type === 'users' && <UserRow row={row} updateForm={updateForm} onDelete={onDelete} key={index} resetPass={resetPass} handleEnableDisable={handleEnableDisable} handleUserCheckUncheck={handleUserCheckUncheck} ></UserRow>}

                </TableRow>
              ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              {rows && <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: -1 }]}
                colSpan={12}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={(e, newPage) => {
                  setPage(newPage);
                }}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                ActionsComponent={TablePaginationActions}
              />}
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </BasicTableDiv>
  );
}

export default BasicTable;